import { alpha, Box, Stack, Typography } from "@mui/material";
import {
  READABLE_BODY_SX,
  READABLE_SECONDARY_SX,
  READABLE_TITLE_SX,
} from "src-next/modules/clinical-insights/constants/clinicalInsightsTheme";

interface InsightPatientsPanelHeaderProps {
  filteredCount: number;
  totalCount: number;
  hasActiveFilter: boolean;
  accentColor: string;
}

export function InsightPatientsPanelHeader({
  filteredCount,
  totalCount,
  hasActiveFilter,
  accentColor,
}: InsightPatientsPanelHeaderProps) {
  const countLabel =
    totalCount > 0 ? `${filteredCount} de ${totalCount}` : `${filteredCount}`;

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1}>
      <Box>
        <Typography fontWeight={700} sx={READABLE_TITLE_SX}>
          Pacientes
        </Typography>
        <Typography color="text.secondary" sx={READABLE_SECONDARY_SX}>
          {countLabel}
        </Typography>
      </Box>
      {hasActiveFilter ? (
        <Typography
          fontWeight={700}
          sx={{
            ...READABLE_SECONDARY_SX,
            px: 1.25,
            py: 0.5,
            borderRadius: 1,
            bgcolor: alpha(accentColor, 0.12),
            color: accentColor,
          }}
        >
          Filtrado
        </Typography>
      ) : null}
    </Stack>
  );
}
